<buyiq-notification *ngFor="let notification of notifications"
                    [@slideInOut]
                    [notification]="notification"
                    (dismissNotification)="onDismissNotification($event)">
</buyiq-notification>
